import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "merlin-overview" }
const _hoisted_3 = { class: "wiki-panel" }
const _hoisted_4 = { class: "role-facts" }
const _hoisted_5 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_SchemaImage = _resolveComponent("SchemaImage")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_localized_text_wrapper = _resolveComponent("localized-text-wrapper")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "good-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('roles.merlin')) + " " + _toDisplayString(_ctx.$t('roles.role')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SchemaImage, {
        class: "merlin-portrait",
        role: "merlin",
        src: _ctx.calculateRoleUrl('merlin'),
        alt: _ctx.$t('roles.merlin'),
        description: _ctx.$t('roles.merlin')
      }, null, 8, ["src", "alt", "description"]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('merlin.factsTitle')), 1),
        _createElementVNode("dl", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['team', 'sees', 'hidden', 'percival', 'loss'], (fact) => {
            return _createElementVNode("div", {
              class: "role-fact",
              key: fact
            }, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$t(`merlin.${fact}Label`)), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_LocalizedTextWrapper, {
                  keypath: `merlin.${fact}Value`
                }, null, 8, ["keypath"])
              ])
            ])
          }), 64))
        ]),
        _createElementVNode("nav", {
          class: "wiki-nav",
          "aria-label": _ctx.$t('wiki.title')
        }, [
          _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('merlin.generalInformationTitle')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "merlin.generalInformationText" })
    ]),
    _createVNode(_component_TopRolePlayer, {
      role: "merlin",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('merlin.generalTipsTitle')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.cautiousKnowledgeTitle')), 1),
        _createElementVNode("span", null, [
          _createVNode(_component_LocalizedTextWrapper, { keypath: "merlin.cautiousKnowledgeText" })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.useHintsWiselyTitle')), 1),
        _createElementVNode("span", null, [
          _createVNode(_component_LocalizedTextWrapper, { keypath: "merlin.useHintsWiselyText" })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.carefulAccusationsTitle')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('merlin.carefulAccusationsText')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.maintainBalanceTitle')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('merlin.maintainBalanceText')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.attentionAssassinTitle')), 1),
        _createElementVNode("span", null, [
          _createVNode(_component_LocalizedTextWrapper, { keypath: "merlin.attentionAssassinText" })
        ])
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('merlin.strategicTipsTitle')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.strategizeSilenceTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('merlin.strategizeSilence')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.revealEvilsTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('merlin.revealEvils')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.utilizeAmbiguityTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('merlin.utilizeAmbiguity')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.buildTrustTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('merlin.buildTrust')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('merlin.supportAlliesTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('merlin.supportAllies')), 1)
      ])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_localized_text_wrapper, { keypath: "merlin.playingAsMerlin" })
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}